import { observer } from 'mobx-react';
import React from 'react';
import { Redirect, Route, RouteProps } from 'react-router';
import { Links } from '~admin/route';
import { useAdminAuthStore } from '~admin/store/admin-auth-store-provider';

export const AuthRoute: React.FunctionComponent<RouteProps> = observer((props) => {
  const adminAuthStore = useAdminAuthStore();
  const { authenticated } = adminAuthStore;

  if (authenticated) {
    return <Route {...props} />;
  }

  return <Redirect to={Links.login(null, { redirect: props.location.pathname })} />;
});



// WEBPACK FOOTER //
// ./route/auth-route.component.tsx